export function config (
  state = {
    layout: 'top-navigation-1',
    background: 'light',
    navbar: 'primary',
    topNavigation: 'light',
    collapsed: true,
    logo: 'info',
    leftSidebar: 'dark',
    rightSidebar: false
  },
  action) {
  switch (action.type) {
    case 'SET_CONFIG':
      return Object.assign({}, state, {
        ...action.config
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/config.js